import { useState, useEffect, useCallback } from 'react';
import Helper from '../helpers';
import config from '../config';

const baseUrl = config.apiBaseUrl;

export const useClassData = (isPublic = false, venueIdentifier = null) => {
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchClasses = useCallback(async () => {
        setLoading(true);
        try {
            if (isPublic) {
                if (venueIdentifier) {
                    // Public endpoint for specific venue (by ID or short key)
                    const res = await fetch(`${baseUrl}/api/classes/public/${venueIdentifier}`);
                    const data = await res.json();
                    setClasses(data);
                } else {
                    // Public endpoint for all classes directory
                    const res = await fetch(`${baseUrl}/api/classes/public`);
                    const data = await res.json();
                    setClasses(data);
                }
            } else {
                // Private endpoint - requires auth
                const token = await Helper.getCookie('wh-jwt');
                const userVenueKey = await Helper.getUserVenueId();
                const res = await fetch(`${baseUrl}/api/classes/user/${userVenueKey}`, {
                    headers: {'Authorization': `Bearer ${token}`}
                });
                const data = await res.json();
                setClasses(data);
            }
        } catch (error) {
            console.error('Error fetching classes:', error);
            setClasses([]);
        } finally {
            setLoading(false);
        }
    }, [isPublic, venueIdentifier]);

    useEffect(() => {
        fetchClasses();
    }, [fetchClasses]);

    return { classes, loading, refetchClasses: fetchClasses };
};
